import React, { useState, useEffect } from 'react';
import { Heart, Stars, Sparkle } from 'lucide-react';

const SuccessModal = () => {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Trigger animation after modal mounts
    setTimeout(() => setShowContent(true), 100);
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Animated background with gradient and particles */}
      <div className="absolute inset-0 bg-gradient-to-br from-red-500/20 to-pink-500/20 backdrop-blur-sm">
        {/* Floating hearts background */}
        {[...Array(20)].map((_, i) => (
          <Heart
            key={i}
            className="absolute text-pink-500/30 animate-float"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
              transform: `scale(${Math.random() * 0.5 + 0.5})`,
            }}
          />
        ))}
      </div>

      {/* Modal content with animations */}
      <div 
        className={`relative bg-white/90 backdrop-blur-md rounded-3xl p-12 max-w-2xl w-full transform transition-all duration-500 shadow-2xl border-2 border-pink-200
          ${showContent ? 'scale-100 opacity-100' : 'scale-90 opacity-0'}`}
      >
        {/* Decorative corners */}
        <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-pink-500 rounded-tl-3xl" />
        <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-pink-500 rounded-tr-3xl" />
        <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-pink-500 rounded-bl-3xl" />
        <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-pink-500 rounded-br-3xl" />

        {/* Floating decorative elements */}
        <Stars className="absolute -top-8 -left-8 w-16 h-16 text-pink-400 animate-spin-slow" />
        <Stars className="absolute -bottom-8 -right-8 w-16 h-16 text-pink-400 animate-spin-slow" />
        <Sparkle className="absolute top-1/4 -right-6 w-12 h-12 text-yellow-400 animate-pulse" />
        <Sparkle className="absolute bottom-1/4 -left-6 w-12 h-12 text-yellow-400 animate-pulse" />

        {/* Content */}
        <div className="relative">
          <div className="text-center space-y-8">
            <div className="space-y-4">
              <h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-rose-600 animate-fade-in-up">
                Yesssss! 💖
              </h2>
              <div className="flex justify-center gap-2 animate-bounce">
                <Heart className="text-red-500 w-8 h-8 fill-current" />
                <Heart className="text-pink-500 w-8 h-8 fill-current" />
                <Heart className="text-red-500 w-8 h-8 fill-current" />
              </div>
            </div>

            <p className="text-2xl text-gray-700 leading-relaxed animate-fade-in">
              Nå er jeg kjempeglad!
              <span className="block mt-4 text-xl text-pink-600 font-medium">
                Jeg lover å gjøre valentinesdagen til din beste noen sinne ! ✨
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;